<template>
	<el-avatar shape="square" :size="size">
		<div class="wai-view" :class="mod">
			<div class="name-text" v-html="nametext" :style="textStyle"></div>
		</div>
	</el-avatar>
</template>

<script>
	export default {
		props: {
			size: {
				type: Number,
				default: 45
			},
			name: {
				type: String,
				default: ""
			},
			fontSize: {
				type: [Number, String],
				default: 14
			},
			mod: {
				type: String,
				default: "", //big
			}
		},
		data() {
			return {
				showValue: this.value
			}
		},
		computed: {
			nametext() {
				let name = this.name.substring(this.name.indexOf('省') + 1)
				name = name.substring(name.indexOf('市') + 1)
				return `${name.substring(0,2)}${name.substring(2,4)}`
			},
			textStyle() {
				let style = ""
				style += `font-size:${this.fontSize}px;`

				return style
			}
		},
		methods: {

		},
	}
</script>

<style lang="scss" scoped>
	.wai-view {
		width: 100%;
		height: 100%;
		line-height: 1;
	}

	.big {
		letter-spacing: 4px;
		line-height: 40px;
	}

	.name-text {
		align-items: center;
		display: flex;
		height: 100%;
		justify-content: center;
		position: relative;
		text-align: center;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		width: 100%;
		padding: 0px 5px;
	}
</style>



// WEBPACK FOOTER //
// avatar-view.vue?38b636b0